module.exports = __webpack_public_path__ + "img/191.0a034368.jpg";